// extracted by mini-css-extract-plugin
module.exports = {"widgetsFilter":"WidgetsFilter_widgetsFilter__3az6-","filters":"WidgetsFilter_filters__3Nqsk"};